export default "__VITE_ASSET__77311a7f__"